import React, { useState } from 'react';
import { checkRouteAddress, finishRoute, HouseProgress, Promoter, RoutePath, takeRouteToCheck } from '../../redux/advertSlice';
import { EmptyPage } from '../EmptyPage';
import { Link, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import {ReactComponent as HouseIcon} from '../../assets/house.svg';
// import HouseIcon from '../../assets/house.svg';
import { Button } from '../../components/Button';
import { Popup } from '../../components/Popup';
import { Input } from '../../components/Input';
import { AddressContentPopup } from './AddressContentPopup';
import { WrapWindow } from '../../components/WrapWindow';
import CopyToClipboardButton from '../../components/CopyToClipboardButton';


function getProgressData(promoter, isCurrentRoute, routeId) {
    const {isFullReport} = promoter;
    const {progress} = isCurrentRoute ? promoter.currentRoute : promoter.routeQueue.find(r => r._id === routeId);

    let successPorchCount = null;
    let successMailboxCount = null
    let spentMailboxCount = null

    if (isFullReport) {
        successPorchCount = progress.reduce((total, cur) => total + cur.donePorches.filter(pInfo => pInfo.photoUrls.length >= 2 && pInfo.videoUrl.name && !pInfo.rejectComment).length, 0)
        successMailboxCount = progress.reduce((total, cur) => total + Math.round(cur.mailboxCount*(cur.donePorches.filter(pInfo => pInfo.photoUrls.length >= 2 && pInfo.videoUrl.name && !pInfo.rejectComment).length/cur.porchCount)), 0)
        spentMailboxCount = progress.reduce((total, cur) => total + Math.round(cur.mailboxCount*(cur.donePorches.filter(pInfo => pInfo.photoUrls.length || pInfo.videoUrl.name).length/cur.porchCount)), 0)
    } else {
        successPorchCount = progress.reduce((total, cur) => total + cur.donePorchUrls.filter(p => !p.rejectComment).length, 0)
        successMailboxCount = progress.reduce((total, cur) => total + Math.round(cur.mailboxCount*(cur.donePorchUrls.filter(p => !p.rejectComment).length/cur.porchCount)), 0)
        spentMailboxCount = progress.reduce((total, cur) => total + Math.round(cur.mailboxCount*(cur.donePorchUrls.length/cur.porchCount)), 0)
    }

    return {successPorchCount, successMailboxCount, spentMailboxCount}
}

function generateRouteReportText(route, promoter, additional, isCurrentRoute) {
    const {porchAmount, offsetPositive, offsetOwnPositive, offsetNegative, offsetComment} = additional;
    const {isFullReport} = promoter;
    const {progress, bet, flyers} = isCurrentRoute ? promoter.currentRoute : promoter.routeQueue.find(r => r._id === route._id);
    let str = '';

    const {successMailboxCount} = getProgressData(promoter, isCurrentRoute, route._id);
    const progressPercent = Math.round((successMailboxCount/route.mailboxCount)*100);

    for (let i = 0; i < progress.length; i++) {
        const h = progress[i];

        const rejectedPorches = isFullReport ?
        h.donePorches.filter((p) => !!p.rejectComment)
        : h.donePorchUrls.filter((p) => !!p.rejectComment);

        const doneCount = isFullReport ?
        h.donePorches.filter((p) => p.photoUrls.length >= 2 && !!p.videoUrl.name && !p.rejectComment).length
        : h.donePorchUrls.filter((p) => !p.rejectComment).length;

        const houseFlyersCount = Math.round(h.mailboxCount*(doneCount/h.porchCount));

        str += `\n${h.name} (${doneCount}/${h.porchCount})`
        if (houseFlyersCount) {
            str += ` ${houseFlyersCount}л. ${(houseFlyersCount*bet).toFixed(2)}руб.`
        }
        if (rejectedPorches.length) {
            str += rejectedPorches.map((p) => `\n\t• ${p.id}п отклонен: (${p.rejectComment})`)
        }
        str += '\n'
    }
    str += '🔻'.repeat(10)

    const result = Math.floor(+(successMailboxCount*bet + (+porchAmount*20*bet)).toFixed(2));

    let resultStr = `Пром ${promoter.fullname}\nМаршрут #${route.id} (выполнен на ${progressPercent}%)
${flyers.map(f => f.name).join(', ')}
•Дата и кол-во ящиков:
${new Date().toLocaleDateString()} = ${successMailboxCount + porchAmount*20}
•Ставка: ${bet}
•Итог: ${result}`

    const add = offsetPositive + offsetOwnPositive - offsetNegative;
    if (offsetPositive || offsetOwnPositive || offsetNegative) {
        resultStr += `\nБонус: ${offsetPositive + offsetOwnPositive - offsetNegative}${offsetComment ?` (${offsetComment})`:''}`
    }
    resultStr += `\n•К оплате ${result + add}`

    return `${resultStr}\n${'🔻'.repeat(10)}${str}`
}

const RouteAddress = ({data, promoter, isCurrentRoute, routeId}) => {
    const {isFullReport, _id: promoterId} = promoter;
    const thisRouteInfo = isCurrentRoute ? promoter.currentRoute : promoter.routeQueue.find(r => r._id === routeId);
    const dispatch = useDispatch();
    
    //general
    const missedPorchCount = data.missedPorches.length; 
    let markedCount = null;
    let allChecked = null;
    let rejectedCount = null;
    let clearCount = null;

    //photo report
    if (!isFullReport) {
        allChecked = !data.donePorchUrls.some(p => !p.checked);
        markedCount = data.donePorchUrls.length + missedPorchCount;
        rejectedCount = data.donePorchUrls.filter(p => p.rejectComment).length;
        clearCount = markedCount - missedPorchCount - rejectedCount;
    }
    const isHouseDone = markedCount === data.porchCount;


    //full report
    const filledPorches = data.donePorches.filter(p => p.videoUrl.name || p.photoUrls.length).map(p => p.id);
    const fullfilledPorches = data.donePorches.filter(p => p.videoUrl.name && p.photoUrls.length >= 2).map(p => p.id);
    const processPorchCount = fullfilledPorches.length + missedPorchCount;
    const isPorchDone = processPorchCount === data.porchCount;

    const checkedPorches = data.donePorches.filter(p => p.checked).map(p => p.id);
    if (isFullReport) {
        markedCount = filledPorches.length;
        allChecked = checkedPorches.length === data.porchCount;
        rejectedCount = data.donePorches.filter(p => p.rejectComment).length;
        clearCount = data.donePorches.filter(p => p.videoUrl.name && p.photoUrls.length >= 2 && !p.rejectComment).length;
    }

    const [popup, setPopup] = useState(null);

    const setPopupHandler = (porchId) => {
        const obj = {houseId: data.houseId, porchId};
        setPopup(obj);
        if (!thisRouteInfo.readyToCheck) return;
        let needToCheck = null;
        if (isFullReport) {
            const thisPorch = data.donePorches.find(p => p.id === porchId);
            needToCheck = thisPorch.photoUrls.length || !!thisPorch.videoUrl.name;
        } else {
            needToCheck = data.donePorchUrls.some(p => !p.checked);
        }
        if (!needToCheck) return;

        if ( (!isFullReport && !allChecked) || (isFullReport && !data.donePorches.find(p => p.id === porchId).checked)) {
            dispatch(checkRouteAddress({...obj, promoterId, routeId}));
            return;
        }
    }

    let popupContent = null;
    if (popup && isFullReport) {
        const selectedPorch = data.donePorches.find(p => p.id === popup.porchId);
        popupContent = selectedPorch.photoUrls.map(ph => ({fileName: ph.name, isPhoto: true, type: 'promHousePhoto'}));
        if (selectedPorch.videoUrl.name) {
            popupContent.push({fileName: selectedPorch.videoUrl.name, isPhoto: false, type: 'promHouseVideo'})
        }
    } else if (popup && !isFullReport) {
        popupContent = data.donePorchUrls.map(ph => ({fileName: ph.name, isPhoto: true, type: 'promHousePhoto'}));
    }

    return (
        <div className="route__address address-item dark-theme-bg1">
            {popup && <AddressContentPopup
                closeFn={() => setPopup(null)}
                content={popupContent}
                isCurrentRoute={isCurrentRoute}
                routeId={routeId}
                promoter={promoter}
                address={data}
                porchId={popup.porchId}
            />}
            <div className="address-item__header">
                <div className="address-item__icon"><HouseIcon width={36} height={36}/></div>
                <div className="address-item__main">
                    <h4>{data.name}</h4>
                    <div>
                        <p>Подъездов: <span>{data.porchCount}</span></p>
                        <p>Квартир: <span>{data.mailboxCount}</span></p>
                    </div>
                </div>
            </div>
            <div className="address-item__body">
                <div className="address-item__row">
                    <div className='address-item__progress'>
                        {isFullReport && <p>
                            {isPorchDone ? 'Отмечены' : processPorchCount ? 'В процессе' : 'Не отмечены'} {!!processPorchCount && `(${processPorchCount}/${data.porchCount})`}
                        </p>}
                        {!isFullReport && <p>
                            {isHouseDone ? 'Отмечены' : markedCount ? 'В процессе' : 'Не отмечены'} {!!markedCount && `(${markedCount}/${data.porchCount})`}
                        </p>}
                        {!!data.missedPorches.length && <p title={data.missedPorches.join(', ')} style={{color: missedPorchCount ? 'darkred' : 'inherit'}}>
                            Проблемных: {data.missedPorches.length || 'нет'}
                        </p>}
                        {!!rejectedCount && <p style={{color: 'red'}}>
                            Отклонено: {rejectedCount}
                        </p>}
                        {!isFullReport && !!clearCount && <p style={{color: 'green'}}>
                            Чистых: {clearCount} ({Math.round(data.mailboxCount*(data.donePorchUrls.filter(p => !p.rejectComment).length/data.porchCount))}ящ.)
                        </p>}
                        {isFullReport && !!clearCount && <p style={{color: 'green'}}>
                            Чистых: {clearCount} ({Math.round(data.mailboxCount*(data.donePorches.filter(p => !p.rejectComment && p.photoUrls.length >= 2 && p.videoUrl.name).length/data.porchCount))}ящ.)
                        </p>}
                    </div>
                    {!isFullReport && <div className='address-item__button'>
                        <Button disabled={!data.donePorchUrls.length} classNames={`${!markedCount?'':allChecked?'checked':''}`} text={allChecked ? 'Просмотрен':'Просмотр'} onClick={() => setPopupHandler(null)}/>
                    </div>}
                    {isFullReport && <div className='address-item__porch-buttons'>
                        {data.donePorches.map(p => 
                            <Button classNames={`${checkedPorches.some(p1 => p1 === p.id) ? 'checked':''} ${data.missedPorches.some(p1 => p1 === p.id) ? 'missed':''} ${p.rejectComment ? 'rejected':''}`}
                            key={p.id} disabled={!filledPorches.some(p1 => p1 === p.id) || data.missedPorches.some(p1 => p1 === p.id)}
                            text={String(p.id)} onClick={() => setPopupHandler(p.id)}/>
                        )}
                    </div>}
                </div>
            </div>
            <div className="route-item__footer">
                {!isFullReport && <div className='address-item__checked-info' style={{color: !markedCount ? 'inherit' : allChecked ? 'green' : 'inherit'}}>
                    {!markedCount ? 'Нет данных' : allChecked ? 'Проверен' : 'Не проверен'}
                </div>}
                {isFullReport && <div className='address-item__checked-info' style={{color: fullfilledPorches.length ? allChecked ? 'green' : checkedPorches.length ? 'yellow' : markedCount ? 'inherit' : 'inherit' : 'inherit'}}>
                    {fullfilledPorches.length ? allChecked ? 'Проверен' : checkedPorches.length ? 'Проверен частично' : markedCount ? 'Не проверен' : 'Нет данных' : 'Нет данных'}
                </div>}
            </div>
        </div>
    )
}

function getHintFinishRoute(data, isFullReport) {
    let isFullfilled = true;
    let isFullChecked = true;
    for (let i = 0; i < data.length; i++) {
        const house = data[i];
        if (isFullReport) {
            for (let j = 0; j < house.donePorches.length; j++) {
                const porch = house.donePorches[j];
                if (porch.photoUrls.length < 2 || !porch.videoUrl.name) {
                    isFullfilled = false;
                }
                if ((porch.photoUrls.length || porch.videoUrl.name) && !porch.checked) {
                    isFullChecked = false;
                }
            }
        } else {
            if (house.porchCount !== house.donePorchUrls.length + house.missedPorches.length) {
                isFullfilled = false;
            }
            if (house.donePorchUrls.some(p => !p.checked)) {
                isFullChecked = false;
            }
        }
    }
    const filledStr = isFullfilled ? null : 'Промоутер отметил не все дома/подъезды на маршруте.'
    const checkedStr = isFullChecked ? null : 'Вы не полностью проверили маршрут.'
    return {filledStr, checkedStr};
}
function checkIsAllChecked(progress, isFullReport) {
    if (isFullReport) {
        for (let i = 0; i < progress.length; i++) {
            const porches = progress[i].donePorches;
            for (let j = 0; j < porches.length; j++) {
                const p = porches[j];
                if ((p.photoUrls.length || !!p.videoUrl.name) && !p.checked) {
                    return false;
                }
            }
        }
    } else {
        for (let i = 0; i < progress.length; i++) {
            const h = progress[i];
            if (h.donePorchUrls.some(p => !p.checked)) {
                return false;
            }
        }
    }
    return true;
}
export const RoutePage = () => {

    const { pathname } = useLocation();
    const routeId = pathname.split('/')[pathname.split('/').length - 1];
    const routes = useSelector((state) => state.advert.routes);
    const promoters = useSelector((state) => state.advert.promoters);
    const thisRoute = routes.find(r => r._id === routeId);
    const dispatch = useDispatch();

    const [porchAmount, setPorchAmount] = useState('');
    const [offsetOwnPositive, setOffsetOwnPositive] = useState('');
    const [offsetPositive, setOffsetPositive] = useState('');
    const [offsetNegative, setOffsetNegative] = useState('');
    const [offsetComment, setOffsetComment] = useState('');

    const [additionalPopup, setAdditionalPopup] = useState(false);
    const [blockingRoute, setBlockingRoute] = useState(true);
    const [needPay, setNeedPay] = useState(true);

    const [isBtnsBlocked, setBtnsBlocked] = useState(false);
    const enableBtns = () => {setBtnsBlocked(false)};

    if (!thisRoute) {
        return <EmptyPage message='Этот маршрут не существует' />
    }
    if (!thisRoute.promoter) {
        return <EmptyPage message='Данный маршрут сейчас не в работе' />
    }
    
    const promoter = promoters.find(p => p.currentRoute._id === thisRoute._id || p.routeQueue.find(rq => rq._id === thisRoute._id));

    const isCurrentRoute = promoter.currentRoute._id === thisRoute._id;
    const {successMailboxCount, spentMailboxCount} = getProgressData(promoter, isCurrentRoute, thisRoute._id);

    const progressPercent = Math.round((successMailboxCount/thisRoute.mailboxCount)*100);

    const additional = {
        porchAmount,
        offsetPositive,
        offsetOwnPositive,
        offsetNegative,
        offsetComment
    }
    const thisRouteInfo = isCurrentRoute ? promoter.currentRoute : promoter.routeQueue.find(r => r._id === thisRoute._id);

    const {bet, flyers} = thisRouteInfo;
    const hasPartnerFlyers = flyers.some(f => !f.isOwn);
    const flyersCount = flyers.length;
    
    const AdditionPopupBody = () => {

        const [porchAmountLocal, setPorchAmountLocal] = useState(porchAmount);
        const [offsetOwnPositiveLocal, setOffsetOwnPositiveLocal] = useState(offsetOwnPositive);
        const [offsetPositiveLocal, setOffsetPositiveLocal] = useState(offsetPositive);
        const [offsetNegativeLocal, setOffsetNegativeLocal] = useState(offsetNegative);
        const [offsetCommentLocal, setOffsetCommentLocal] = useState(offsetComment);

        return (
            <div className='route-additional-popup'>
            <div className='route-additional-popup__info'>
                <span>Видов листовок: {flyersCount}</span>
                <span>Ставка: {bet} руб/ящик</span>
            </div>
            <div className='route-additional-popup__section'>
                <p>Укажите количество подъездов, в которых листовки были оставлены у консьержа или на подоконнике</p>
                <div>{/*@ts-ignore*/}
                    <Input min={0} onBlur={() => setPorchAmount(porchAmountLocal)} label='Кол-во подъездов' type='number' value={porchAmountLocal} changeHandler={(e) => setPorchAmountLocal(+e.target.value)}/>
                    <span>x 20л. = {+porchAmountLocal*20} листовок = + {(+porchAmountLocal*20*bet).toFixed(2)} руб прому</span>
                </div>
            </div>
            <hr />
            <div className='route-additional-popup__section'>
                <p>Укажите суммы, которые нужно прибавить и убавить от общей суммы маршрута (бонусы, штрафы)</p>
                <div>
                    <div>{/*@ts-ignore*/}
                    <Input onBlur={() => setOffsetOwnPositive(offsetOwnPositiveLocal)} min={0} label='Личные начисления, руб' type='number' value={offsetOwnPositiveLocal} changeHandler={(e) => setOffsetOwnPositiveLocal(Math.abs(+e.target.value))} />{/*@ts-ignore*/}
                    {hasPartnerFlyers && <Input onBlur={() => setOffsetPositive(offsetPositiveLocal)} min={0} label='Общие начисления, руб' type='number' value={offsetPositiveLocal} changeHandler={(e) => setOffsetPositiveLocal(Math.abs(+e.target.value))} />}{/*@ts-ignore*/}
                    <Input onBlur={() => setOffsetNegative(offsetNegativeLocal)} min={0} label='Отчисления, руб' type='number' value={offsetNegativeLocal} changeHandler={(e) => setOffsetNegativeLocal(Math.abs(+e.target.value))} />
                    </div>
                    <textarea className='dark-theme-bg0' onBlur={() => setOffsetComment(offsetCommentLocal)} value={offsetCommentLocal} placeholder={`Комментарий (необязательно)\nНапример, +бонус, -штраф`} onChange={(e) => setOffsetCommentLocal(e.target.value)} />
                </div>
            </div>
            </div>
        )
    }

    function getRouteTotalPayment() {
        const additionFlyers = porchAmount ? ` + (${bet} руб x ${porchAmount}п. x 20л.)` : '';
        const sumPlusOwn = offsetOwnPositive ? `\n+ ${offsetOwnPositive} руб` : '';
        const sumPlus = offsetPositive ? `\n+ ${offsetPositive} руб` : '';
        const sumMinus = offsetNegative ? `\n- ${offsetNegative} руб` : '';
        const total = Math.floor(+(bet*successMailboxCount + bet*(+porchAmount)*20+(+offsetPositive)+(+offsetOwnPositive)-(+offsetNegative)).toFixed(2));
        return `${bet} руб x ${successMailboxCount}ящ${additionFlyers}${sumPlus}${sumPlusOwn}${sumMinus} = ${total} руб (всего листовок потрачено: ${spentMailboxCount + (+porchAmount || 0)*20})`
    }
    const {progress} = thisRouteInfo;
    const {isFullReport} = promoter;

    const takeRouteToCheckHandler = () => {
        const isAllChecked = checkIsAllChecked(progress, isFullReport);
        if (thisRouteInfo.readyToCheck && !isAllChecked) {
            alert('Чтобы отправить маршрут на доработку, сначала проверьте весь отправленным промоутером контент!')
            return;
        }
        setBtnsBlocked(true);
        dispatch(takeRouteToCheck({
            promoterId: promoter._id,
            routeId: routeId,
            isRevision: thisRouteInfo.readyToCheck,
            enableBtns,
        }));
    }
    const finishRouteHandler = () => {
        const hasExcessPhotos = !isFullReport ? progress.some(h => h.donePorchUrls.length > h.porchCount - h.missedPorches.length) : false;
        if (hasExcessPhotos) {
            alert('Некоторые из домов имеют лишние фотографии - для завершения маршрута необходимо их удалить')
            return;
        }
        const {checkedStr, filledStr} = getHintFinishRoute(progress, isFullReport)
        if (checkedStr || filledStr) {
            if (!window.confirm(`${filledStr?filledStr+'\n':''}${checkedStr?checkedStr+'\n':''}\nВсё равно завершить маршрут?`)) {
                return;
            }
        }
        setBtnsBlocked(true);
        dispatch(finishRoute({
            promoterId: promoter._id,
            routeId,
            addPorchCount: +porchAmount,
            plusPayment: +offsetPositive,
            plusPaymentOwn: +offsetOwnPositive,
            minusPayment: +offsetNegative,
            addPaymentComment: offsetComment,
            blocking: blockingRoute,
            needPay,
            enableBtns
        }))
    }

    const ReportBody = () => {

        const AddressItem = ({name, mailboxCount, porchCount, donePorches, donePorchUrls}) => {
            const rejectedPorches = isFullReport ?
                donePorches.filter((p) => !!p.rejectComment)
                : donePorchUrls.filter((p) => !!p.rejectComment);

            const doneCount = isFullReport ?
                donePorches.filter((p) => p.photoUrls.length >= 2 && !!p.videoUrl.name && !p.rejectComment).length
                : donePorchUrls.filter((p) => !p.rejectComment).length;
    
            const houseFlyersCount = Math.round(mailboxCount*(doneCount/porchCount));
            return (
                <li className='route__report-item'>
                    <div>
                        <div>{name}</div>
                        <div>({doneCount}/{porchCount})</div>
                        {!!doneCount && <div>{houseFlyersCount}л</div>}
                        {!!doneCount && <div>{(houseFlyersCount*bet).toFixed(2)}руб</div>}
                    </div>
                    {!!rejectedPorches.length && <ul className='route__report-reject-info'>
                        {rejectedPorches.map((p, i) => <li key={`${p.id}_${i}`}>{p.id}п отклонен: ({p.rejectComment})</li>)}
                    </ul>}
                </li>
            )
        }

        const total = Math.floor(+((bet*successMailboxCount + bet*(+porchAmount)*20+(+offsetPositive)+(+offsetOwnPositive)-(+offsetNegative)).toFixed(2)));
        return (
            <ul className='route__report-list'>
                {progress.map(h => <AddressItem key={h.houseId} mailboxCount={h.mailboxCount} porchCount={h.porchCount} name={h.name} donePorches={h.donePorches || []} donePorchUrls={h.donePorchUrls} />)}
                {(!!porchAmount || !!offsetPositive || !!offsetOwnPositive || !!offsetNegative) && <div className="route__report-additional-item">
                    <span>Дополнительно:</span>
                    {!!porchAmount && <p>{porchAmount}п. по 20 листовок = {+porchAmount*20}л. = {+porchAmount*20*bet} руб</p>}
                    {(!!offsetPositive || !!offsetOwnPositive || !!offsetNegative) && <p>{offsetPositive ? `+${offsetPositive}руб `:''}{offsetOwnPositive ?`+ ${offsetOwnPositive} руб `:''}{offsetNegative ?`- ${offsetNegative} руб `:''}= {+offsetPositive +(+offsetOwnPositive) - +offsetNegative}руб{offsetComment ? ` (${offsetComment})`:''}</p>}
                </div>}
                <div className="route__report-results-item">
                    <span>Итого:</span>
                    <p>{total} рублей за маршрут</p>
                </div>
            </ul>
        )
    }
    const ReportFooter = () => {
        const setTextCopyHandler = () => {
            return generateRouteReportText(thisRoute, promoter, additional, isCurrentRoute);
        }
        return (
            <div style={{textAlign:'center'}}>
                <CopyToClipboardButton className='button' setTextToCopy={setTextCopyHandler}/>
            </div>
        )
    }

    const sortedAddresses = [...progress].map(pr => ({...pr, orderIndex: isFullReport ? Number(!!pr.donePorches.find(dp => dp.photoUrls.length || dp.videoUrl.name)) : Number(!!pr.donePorchUrls.length)}))
    .sort((a,b) => b.orderIndex - a.orderIndex);

    return (
        <div className='route'>
            {additionalPopup && <Popup 
                button={<Button text='Сохранить' onClick={() => setAdditionalPopup(false)} />}
                closeFn={() => setAdditionalPopup(false)} closeWithOutsideClick={false} title='Дополнить маршрут'
                children={<AdditionPopupBody />}
            />}
            <div className="route__header">
                <h2>Маршрут #{thisRoute.id} | {promoter.fullname} | выполнен на {progressPercent}%
                    <Link className='button' to={`../../map?routeId=${thisRoute.id}`}>Показать на карте</Link>
                </h2>
            </div>
            <div className="route__body">
                <WrapWindow minWidth={'490px'} maxWidth={'490px'} title={`Отчёт по маршруту #${thisRoute.id}`} subtitle={promoter.fullname} body={<ReportBody />} footer={<ReportFooter />} />
                <div className="route__addresses-grid">
                    {sortedAddresses.map(addr => <RouteAddress isCurrentRoute={isCurrentRoute} routeId={thisRouteInfo._id} promoter={promoter} key={addr.houseId} data={addr} />)}
                </div>
            </div>
            <div className="route__footer">
                <div className="route__payment-hint">
                    Итого за маршрут: {getRouteTotalPayment()}
                </div>
                <div className="route__buttons">
                    <Button disabled={isBtnsBlocked} text={thisRouteInfo.readyToCheck ? 'Отправить на доработку':'Начать проверку'} onClick={takeRouteToCheckHandler} />
                    <Button disabled={isBtnsBlocked || !thisRouteInfo.readyToCheck} text="Завершить маршрут" onClick={finishRouteHandler} />
                    <div>
                        <div><input id='block-route' type='checkbox' checked={blockingRoute} onChange={() => setBlockingRoute(prev => !prev)}/><label htmlFor='block-route' style={{marginLeft: '6px'}}>Блокировать маршрут</label></div>
                        <div><input id='pay-route' type='checkbox' checked={needPay} onChange={() => setNeedPay(prev => !prev)}/><label htmlFor='pay-route' style={{marginLeft: '6px'}}>Оплачиваемый</label></div>
                    </div>
                    <Button text="Дополнить" onClick={() => setAdditionalPopup(true)} />
                </div>
            </div>
        </div>
    );
};
